import { useEffect, useState } from 'react';
import { useAuthContext } from '@/context/AuthContext';

const useAuthTokenManager = () => {
  const { isTokenValid, refreshToken, token } = useAuthContext();
  const [isCheckingToken, setCheckingToken] = useState(true);

  useEffect(() => {
    const checkAndRefreshToken = async () => {
      if (!isTokenValid) {
        refreshToken({ onSuccess: () => setCheckingToken(false) });
      } else {
        setCheckingToken(false);
      }
    };
    checkAndRefreshToken();
  }, [isTokenValid, refreshToken, token]);

  return { isCheckingToken };
};

export default useAuthTokenManager;
